import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Cellular: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m165 510v150h-30v-120c0-16.57 13.43-30 30-30zm120-90v240h-30v-210c0-16.57 13.43-30 30-30zm240-180v420h-30v-390c0-16.57 13.43-30 30-30zm-120 90v330h-30v-300c0-16.57 13.43-30 30-30zm240-180v510h-30v-480c0-16.57 13.43-30 30-30z' />
  </IconBase>
));

Cellular.displayName = 'Cellular';

export default Cellular;
